import { createSelector } from 'reselect';

import { getMerchantCountry } from '@/selectors/merchant';

export const formatAddress = ({ street, postalCode, city, country } = {}) =>
  `${street}, ${postalCode} ${city}, ${country}`;

export const isUSRegionCountry = country => ['US', 'MX', 'CA'].includes(country);

export const isAddressRegionOptional = createSelector(
  getMerchantCountry,
  merchantCountry => merchantCountry !== 'US',
);

export const getTPrefix = merchantCountry => {
  if (isUSRegionCountry(merchantCountry)) return 'products-fe.containers.us_company_details';
  return 'products-fe.containers.uk_company_details';
};
